import {
  FETCH_PRODUCT_VIDEOS,
  CREATE_PRODUCT_VIDEO,
  DELETE_PRODUCT_VIDEO
} from "../../store/constants/hwk";

export function fetchProductVideos() {
  return {
    type: FETCH_PRODUCT_VIDEOS
  };
}

export function createProductVideo(payload = {}) {
  return {
    type: CREATE_PRODUCT_VIDEO,
    payload
  };
}

export function deleteProductVideo(productId = null, videoId = null) {
  return {
    type: DELETE_PRODUCT_VIDEO,
    productId,
    videoId
  };
}
